import React, { Suspense, lazy } from 'react'
import { useSelector } from 'react-redux'
import Unauthorized from './Unauthorized'

function MRoute({ _comp, _sPath }) {
    const user = useSelector(state=> state.user.user)

    const LazyComponent = lazy(()=> import(`./${_comp}`))
  return (
    <Suspense fallback={'ERROR'}>
        {(user && user.role === 'manager')? <LazyComponent sPath={_sPath? _sPath: null}/> : <Unauthorized />}
    </Suspense>
  )
}

export default MRoute